import Morizen from "../../media/logo/morizen.webp";
import Magenta from "../../media/logo/magenta.webp";
import Soultan from "../../media/residential/6.png";
import Mulberry from "../../media/logo/mulberry.webp";
import Burgundy from "../../media/logo/burgundy.webp";
import Olive from "../../media/logo/olive.webp";
import Primrose from "../../media/logo/theprimerose.webp";
import Springlake from "../../media/logo/springlake.webp";
import Crystal from "../../media/logo/crystal.webp";

const images = [
  Morizen,
  Soultan,
  Magenta,
  Mulberry,
  Burgundy,
  Olive,
  Primrose,
  Springlake,
  Crystal,
];

export default images;
